/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SudoWrapper_viewer = {
    readonly id: string;
    readonly sudo: {
        readonly " $fragmentRefs": FragmentRefs<"SudoTriggerClientUpdate_sudo">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SudoSwitchUser_viewer" | "SudoModifyUser_viewer" | "SudoDeleteEverything_viewer">;
    readonly " $refType": "SudoWrapper_viewer";
};
export type SudoWrapper_viewer$data = SudoWrapper_viewer;
export type SudoWrapper_viewer$key = {
    readonly " $data"?: SudoWrapper_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SudoWrapper_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SudoWrapper_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Sudo",
            "kind": "LinkedField",
            "name": "sudo",
            "plural": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SudoTriggerClientUpdate_sudo"
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SudoSwitchUser_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SudoModifyUser_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SudoDeleteEverything_viewer"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '846c7be18bf8da2b58f3ecc218351eb9';
export default node;
